<template>
  <div class="form-row">
    <div class="form-label">{{ info.displayName }}</div>
    <div class="form-contro">
      <a-radio
        v-for="o in info.listOptions"
        :key="o.optionValue"
        @change="info.setValue($event, o)"
        :value="o.optionValue"
        :disabled="info.disabled"
        :checked="info.model == o.optionValue"
      >
        {{ o.optionValue }}
      </a-radio>
    </div>
    <div class="form-error" v-if="info.dirty && info.invalid">
      {{ info.validationMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SRadio",
  props: {
    info: {}
  }
};
</script>

<style scoped></style>
